define.alias("shared/components/shared/plan-recommendation/recommendation", "settings/components/shared/plan-recommendation/recommendation");